module.exports = __webpack_public_path__ + "img/landing.e12745e1.png";